{
  "apiContext": {
    "v4": {
      "assetsUrl": "https://cdn-prod.scalefast.com/public/assets",
      "apiVersion": "v10",
      "zendeskGetFormBaseEndpoint": "/zendesk/ticket_form",
      "zendeskSendFormBaseEndpoint": "/zendesk/ticket",
      "zendeskFormID": "5789758078994",
      "storeSearchBaseUrl": "https://storesearch.eu.scalefast.com/StoreSearch",
      "environment": "production",
      "userID": "20430613",
      "clientId": "ED9B7BD928CD82EE57A8D9D1EEDF7470",
      "projectId": "1299",
      "territoryId": "ES",
      "store_id": 2,
      "apiKey": "ED9B7BD928CD82EE57A8D9D1EEDF7470",
      "pepStorageKey": "pep_storage_oralb-es-store",
      "locale": "es_ES"
    },
    "v5": {
      "clientSecret": "ec3c63ec407ac738af5df0a67f12ef894179464d89767c7bdf124818980e411e",
      "projectId": "1299",
      "territoryId": "FR",
      "apiKey": "5457D4CDE0F28FC5EA15A07F65EF4DAF",
      "store_id": 2,
      "grantTypeM2M": "password",
      "grantTypeStore": "client_credentials",
      "clientIdM2M": "c068011f63cf932a47096317a86dea7b",
      "clientIdStore": "8d8e0cdb52b3d0f1d7553312e1e82385",
      "paymentBaseUrl": "https://pay-v5.scalefast.ninja",
      "komojuBaseUrl": "https://komoju.com",
      "baseUrl": "v5.example.com"
    },
    "v4StoreSearch": {
      "userID": "20430694",
      "env": ""
    }
  },
  "credentialsConfig": {
    "accessToken": {
      "implementation": "session-storage",
      "expiration": 100000
    }
  },
  "cartStorageConfig": {
    "implementation": "v4-local-storage"
  }
}